module.exports = __webpack_public_path__ + "static/media/icon_bus.7103604b.png";